export const LIGHTDASH_APP_NAME = 'lightdash_webapp';
